import { RewardSettings, TherapyProfile } from '../../services/profileService';
import { getProfileAgeDisplay } from './profileAge';

export type EffectiveProfileRewards = {
    age: number;
    usesFallbackAge: boolean;
    settings: RewardSettings;
};

export function getEffectiveProfileRewards(
    profile: TherapyProfile,
    birthdate?: string,
    today: Date = new Date(),
): EffectiveProfileRewards {
    const ageDisplay = getProfileAgeDisplay(birthdate, today);
    const age = ageDisplay?.age ?? profile.fallback_age;
    const usesFallbackAge = ageDisplay === null;

    if (profile.manual_rewards) {
        return {
            age,
            usesFallbackAge,
            settings: {
                questionnaire_energy: profile.questionnaire_energy,
                expo_energy: profile.expo_energy,
                nachsorge_energy: profile.nachsorge_energy,
                questionnaire_stars: profile.questionnaire_stars,
                expo_stars: profile.expo_stars,
                nachsorge_stars: profile.nachsorge_stars,
            },
        };
    }

    return {
        age,
        usesFallbackAge,
        settings: {
            questionnaire_energy: age * profile.questionnaire_energy_per_year,
            expo_energy: age * profile.expo_energy_per_year,
            nachsorge_energy: age * profile.nachsorge_energy_per_year,
            questionnaire_stars: age * profile.questionnaire_stars_per_year,
            expo_stars: age * profile.expo_stars_per_year,
            nachsorge_stars: age * profile.nachsorge_stars_per_year,
        },
    };
}
